export default {"src":"/_next/static/media/chevron_down.b46d20d1.svg","height":5,"width":10};